import { createContext } from "react";
import { useContext } from "react";
import type { PropsWithChildren } from "react";

import { Title as TitleComponent } from "./Title";

interface PriceProviderProps {
  Title: typeof TitleComponent;
}

const PriceProvider = createContext<PriceProviderProps>({
  Title: TitleComponent,
});

PriceProvider.displayName = "PriceProvider";

export const usePriceProviderContext = () => useContext(PriceProvider);

interface PriceContextProps {
  Title: typeof TitleComponent;
}

export const PriceContextProvider = ({
  children,
  Title = TitleComponent,
}: PropsWithChildren<PriceContextProps>) => {
  const values = {
    Title,
  };

  return (
    <PriceProvider.Provider value={values}>{children}</PriceProvider.Provider>
  );
};
